<template>
    <div
    class="modal right fade trader-info"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <div v-if="this.addAsProspect">
                <h5 class="modal-title">ADD PROSPECT</h5>
            </div>
            <div v-else>
                <h5 class="modal-title" v-if="!customerData.id">Add Customer</h5>
                <h5 class="modal-title" v-if="customerData.id">Edit Customer</h5>
            </div>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="inputEmail4">First Name</label>
                        <input  type="text" class="form-control" id="inputEmail4" placeholder="First name"  v-model="customerData.customerFirstName" >
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputLast">Middle Name</label>
                        <input type="text" class="form-control" id="inputLast" placeholder="Middle name"  v-model="customerData.customerMiddleName" >
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 required">
                        <label for="inputLast">Last Name</label>
                        <input type="text" class="form-control" id="inputLast" placeholder="Last name"  v-model.trim="customerData.customerLastName" > 
                    </div>    
                    <div class="form-group col-md-6">
                        <label for="inputLocation">Email</label>
                        <input type="email" class="form-control" placeholder="Email"  v-model="customerData.customerEmail">
                    </div>
                </div>
                <div class="form-row">
                     <div class="form-group col-md-6">
                        <label for="inputEmail4">Title</label>
                        <select class="form-control" v-model="customerData.customerTitle" >
                        <option
                            v-for="titile in ['SIR', 'MR', 'MS', 'MA_AM', 'MRS']"
                            :key="titile"
                            v-bind:value="titile"
                        >{{capitalizeFirstLetter(titile)}}</option>
                    </select>
                    </div>
                </div>    
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <div v-if="this.addAsProspect">
                        <button type="button" class="btn btn-primary" @click="addProspect()">ADD PROSPECT</button>
                    </div>
                    <div v-else>
                        <button v-if="!customerData.id" type="button" class="btn btn-primary" @click="addCustomer()">ADD CUSTOMER</button>
                        <button v-if="customerData.id" type="button" class="btn btn-primary" @click="updateCustomer()">UPDATE CUSTOMER</button>
                    </div>
                    
                </div>
            </form>
        </div>
        </div>
    </div>
    </div>
</template>

    <script>
    import authService from "@/authService";
    import config from "@/config";

    export default {
        name: 'customerAddmodal',
        components :{
            
        },
        props: ['customerData','addAsProspect'],
        data() {
            return {
                loading : false,
                errors: []
            };
        },
        methods: {   
            capitalizeFirstLetter(string) {
                string = string.toLowerCase().replace('_' , "'");
                // console.log(string)
                if(string == 'mr' || string == 'ms' || string == 'mrs'){
                    string = string+ '.'
                }
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            addProspect(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = {
                        customerFirstName:this.customerData.customerFirstName,
                        customerLastName:this.customerData.customerLastName,
                        customerMiddleName:this.customerData.customerMiddleName,
                        customerEmail: this.customerData.customerEmail,
                        customerTitle : this.customerData.customerTitle ? this.customerData.customerTitle : null,
                        status:"ACTIVE",
                        type: "CUSTOMER",
                        accountType: "Cash",
                        accMapStatus:"ACTIVE",
                        accStatus : "ACTIVE"
                    };
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .post(config.baseUrlBidSide + "/customer/prospect?cognitoSub="+authService.getUser().cognitoSub, addData, auth)
                    .then(() => {
                        this.loading = false;            
                        this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            addCustomer(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = {
                        customerFirstName:this.customerData.customerFirstName,
                        customerLastName:this.customerData.customerLastName,
                        customerMiddleName:this.customerData.customerMiddleName,
                        customerEmail: this.customerData.customerEmail,
                        spread:this.customerData.spread,
                        customerTitle : this.customerData.customerTitle ? this.customerData.customerTitle : null
                    };
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .post(config.baseUrlBidSide + "/customer", addData, auth)
                    .then(() => {
                        this.loading = false;              
                        this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            updateCustomer(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = { ...this.customerData};
                    addData.customerTitle =  this.customerData.customerTitle ? this.customerData.customerTitle : null
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .put(config.baseUrlBidSide + "/customer", addData, auth)
                    .then(() => {
                        this.loading = false;              
                        this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            checkForm(){
                this.errors = [];
                // if (!this.customerData.customerFirstName) {
                //     this.errors.push("Customer first name is required.");
                //     return false;
                // }
                if (!this.customerData.customerLastName) {
                    this.errors.push("Customer last name is required.");
                    return false;
                }
                // if(!this.customerData.customerEmail){
                //     this.errors.push("Email is required");
                //     return false;
                // }
                 if(this.customerData.customerEmail && !this.validateEmail(this.customerData.customerEmail)){
                    this.errors.push("You have entered an invalid email address!");
                    return false;
                }
                // if (!this.customerData.customerTitle) {
                //     this.errors.push("Title is required.");
                //     return false;
                // }
                return true
            }

        },
        mounted(){
            //if(this.addAsProspect) this.customerData = {}
        }
    };
    </script>